<template>
    <div>
        <div class="form__group">
            <label v-if="!isMain" class="form__label  form__label--block">{{ getTranslation('state') }} <span v-if="required" class="required">*</span> </label>
            <v-select
                    ref="statesFilter"
                    v-model="stateId"
                    :options="states"
                    :reduce="option=>option.id"
                    @search:blur="!stateId ? customValidator.stateId = false : customValidator.stateId = true"
                    :class="{ 'field--error': !customValidator.stateId }"
                    :placeholder="getTranslation('selectFromList')"
                    label="name"
                    :filter-by="option => option.fullText"
            />
        </div>
        <div v-for="(subdivision,index) in subdivisions" class="form__group">
            <label class="form__label  form__label--block">{{ getTranslation('subdivision') }}</label>
            <v-select
                    v-model="subTree[index]"
                    :options="subdivision"
                    :reduce="option=>option.id"
                    :placeholder="getTranslation('selectFromList')"
                    label="name"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "StatesFilter",
        props: {
            required: {
                type: Boolean,
                default: false
            },
            isMain: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                customValidator: {
                    stateId: true,
                },
                filterForm: {},
                states: [],
                subdivisions: [],
                subTree: [],
                currentSubTreeId: '',
                stateId: '',
                subdivisionId: '',
                timer: null,
                showSelect: false,
                indexNull: null,
            }
        },
        watch: {
            'stateId'( id ) {
                this.$emit( 'input', id );
                this.subdivisions = [];
                this.subTree = [];
                let isMainStates = false;
                let isSub = true;
                if ( !id ) {
                    isMainStates = true;
                    isSub = false;
                }


                this.fetchStates( isMainStates, id, isSub );
            },
            'subTree'( arr ) {

                let i = 0;
                for ( let item of arr ) {
                    if ( item !== null && item !== undefined && item !== '' ) {

                    }
                    else {
                        this.indexNull = i;
                    }
                    i++;
                }

                let lastIndex = 0;
                let arrLength = arr.length
                if ( arrLength > 1 )
                    lastIndex = arrLength - 1;

                let idValue = arr[lastIndex];

                let isMainStates = false;
                let isSub = true;

                if ( idValue ) {
                    this.$emit( 'input', idValue );
                }
                else {
                    this.$emit( 'input', this.stateId );
                    isMainStates = true;
                    isSub = false;
                }


                if ( arr.length > 0 )
                    this.fetchStates( isMainStates, idValue, isSub );
            }
        },
        created() {
            this.fetchStates( true );
        },
      mounted() {
        let searchInput = this.$refs.statesFilter.$el.getElementsByClassName( 'vs__search' ),
            searchText = '';
        if ( searchInput.length > 0 ) searchInput[0].oninput = e => {
          if ( this.timer ) clearTimeout( this.timer );
          if ( searchText !== e.target.value ) {
            this.timer = setTimeout( () => {
              searchText = e.target.value;
              this.searchState( searchText );
              this.timer = null;
            }, 500 );
          }
        };
      },

        methods: {
            fetchStates( mainStates = false, parentId = null, isSubdivision = false ) {
                let params = {};

                if ( this.indexNull !== null ) {

                    this.subTree.splice( this.indexNull );

                    if ( this.indexNull !== 0 )
                        this.subdivisions = this.subdivisions.slice( 0, this.indexNull );
                    else
                        this.subdivisions.splice( ( this.indexNull + 1 ) );

                    this.indexNull = null;
                }


                if ( this.isMain ) {
                    params.mainStates = true;
                    isSubdivision = false;
                }
                else {
                    if ( parentId ) {
                        params.parentId = parentId;
                        isSubdivision = true;
                    }

                    else {
                        params.mainStates = true;
                        isSubdivision = false;
                    }
                }

                return this.axios.get( this.$config.urls.application.fetchStateResources.url, { params } )
                           .then( response => {
                               if ( parentId && isSubdivision ) {
                                   if ( response.data.data.length > 0 )

                                       if ( this.subTree.filter( id => id === parentId ).length <= 1 )
                                       {
                                         let statesData = response.data.data.map( state => {
                                           state.fullText = JSON.stringify( state );
                                           return state;
                                         } );

                                         this.subdivisions.push(statesData );
                                       }
                               }
                               else
                                   this.states = response.data.data.map( state => {
                                     state.fullText = JSON.stringify( state );
                                     return state;
                                   } );
                           } )
            },
            searchState( searchText ) {
                let params = {};
                if ( searchText ) params.query = searchText;

                params = this.cleanObject( { ...params, ...this.filterForm } );

                return this.axios.get( this.$config.urls.application.fetchStateResources.url, { params: params } )
                           .then( response => {
                               this.states = response.data.data.map( state => {
                                 state.fullText = JSON.stringify( state );
                                 return state;
                               } );
                           } )
            },

            // We will call this method from parent component for check validity
            checkValidity() {
                if ( !this.stateId ) {
                    this.customValidator.stateId = false;
                    return false;
                }

                return true;
            }
        }
    }
</script>

<style scoped>

</style>
